// extracted by mini-css-extract-plugin
module.exports = {"container":"i_A0","icon":"i_A1","text":"i_A2"};